import { HostListener, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SCREEN_SIZE } from '../models/screen-size.enum';

@Injectable({
  providedIn: 'root',
})
export class SizeDetectorService {
  private resizeSubject = new BehaviorSubject<SCREEN_SIZE>(SCREEN_SIZE.XL);
  currentData = this.resizeSubject.asObservable();
  currentValue = this.resizeSubject.getValue();

  constructor() {
    this.updateSize(window.innerWidth);
  }

  updateSize(width: number) {
    const size = this.sizeDetector(width);
    this.resizeSubject.next(size);
  }

  sizeDetector(width: number) {
    if (width >= 1400) return SCREEN_SIZE.XL;
    else if (width >= 1200) return SCREEN_SIZE.LG;
    else if (width >= 1024) return SCREEN_SIZE.MD;
    else if (width >= 576) return SCREEN_SIZE.SM;
    else return SCREEN_SIZE.XS;
  }
}
